import React, { FC } from 'react';
import AppleSignIn from 'react-apple-signin-auth';
import { AppleIcon } from '../../../commons/icons/Apple';
import { TextButton } from '../../../commons/buttons/TextButton';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { AppleConnectAuthError, AppleLoginResponse } from '../../../../models/Socials';
import {
  appleClientId,
  appleClosePopupErrorMessage,
  appleTriggerNewSignInMessage,
} from '../../../../constants/configuration';

interface ILoginWithAppleId {
  onSuccess: (res: AppleLoginResponse) => void;
}

export const LoginWithAppleId: FC<ILoginWithAppleId> = ({ onSuccess }) => {
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const redirectURI = window.location.href;

  const handleAppleLoginError = (err: AppleConnectAuthError) => {
    if (err && ![appleClosePopupErrorMessage, appleTriggerNewSignInMessage].includes(err.error)) {
      customEnqueueSnackbar(err.error, 'error');
    }
  };

  return (
    <AppleSignIn
      authOptions={{
        clientId: appleClientId,
        scope: 'email name',
        redirectURI,
        state: 'state',
        nonce: 'nonce',
        usePopup: true,
      }}
      uiType="dark"
      noDefaultStyle={false}
      buttonExtraChildren="Continue with Apple"
      onSuccess={(response) => onSuccess(response)}
      onError={(error) => handleAppleLoginError(error)}
      skipScript={false}
      iconProp={{ style: { marginTop: '10px' } }}
      render={(renderProps) => (
        <TextButton
          label={<AppleIcon className="login-socials__item" />}
          handleClick={renderProps.onClick}
          className="unstyled"
        />
      )}
    />
  );
};
